import {
  POST_POSTCODE_REQUEST,
  POST_POSTCODE_SUCCESS,
  POST_POSTCODE_FAILURE,
  POST_MULTI_POSTCODES_REQUEST,
  POST_MULTI_POSTCODES_SUCCESS,
  POST_MULTI_POSTCODES_FAILURE,
} from '../../constants/ActionTypes'

import { CommonApi } from '../api/CommonApi';
import * as errMessages from '../../constants/ErrorMessages';
import { HTTP_200_OK_CODE } from "../../constants/HttpStatusCode";

/*** validate Postcode ***/

const postPostcodeRequest = () => ({
  type: POST_POSTCODE_REQUEST,
});

const postPostcodeSuccess = () => ({
  type: POST_POSTCODE_SUCCESS
});

const postPostcodeFailure = (error) => ({
  type: POST_POSTCODE_FAILURE,
  payload: {
    error: error,
  }
})

export const postPostcode = (postcode) => {
  return (dispatch) => {
    dispatch(postPostcodeRequest());

    return CommonApi.zipcloud(postcode, dispatch)
      .then((response) => {
        if (isValidPostcode(response)) {
          dispatch(postPostcodeSuccess());
        } else {
          throw new Error(errMessages.ERR_POSTCODE_NOT_FOUND);
        }
      }).catch(error => {
        if (window.confirm(errMessages.ERR_POST_POSTCODE_FAILED)) {
          //log error and let it thru
          dispatch(postPostcodeFailure({}));
        } else {
          //throw error
          throw error;
        }
      })
  };
}

const postMultiPostcodesRequest = () => ({
  type: POST_MULTI_POSTCODES_REQUEST,
});

const postMultiPostcodesSuccess = () => ({
  type: POST_MULTI_POSTCODES_SUCCESS
});

export const postMultiPostcodesFailure = (error) => ({
  type: POST_MULTI_POSTCODES_FAILURE,
  payload: {
    error: error,
  }
})

export const postMultiPostcodes = (postcodes) => {
  return (dispatch) => {
    dispatch(postMultiPostcodesRequest());

    let requests = postcodes.map(postcode => CommonApi.zipcloud(postcode, dispatch));

    return Promise.all(requests)
      .then((response) => {
        let succeeded = true;
        let errors = [];

        for (let i = 0; i < response.length; i++) {
          if (!isValidPostcode(response[i])) {
            errors[i] = { post_code: errMessages.ERR_POSTCODE_NOT_FOUND };
            succeeded = false;
          } else {
            errors[i] = {};
          }
        }

        if (succeeded) {
          dispatch(postMultiPostcodesSuccess());
        } else {
          throw errors;
        }
      }).catch(error => {
        let errorCount = 0;
        error.forEach(e => {
          if (Object.keys(e).length > 0) errorCount++;
        })

        if (window.confirm(`${error.length}件のうち、${errorCount}件の住所が存在しないようです。そのまま登録しますか？`)) {
          //log error let it thru
          dispatch(postMultiPostcodesSuccess());
        } else {
          //throw error
          throw error;
        }
      })
  };
}

/***
* chains Postcode with another action
*/
export const postPostcodeAnd = (data, action) => {
  return dispatch => {
    return dispatch(postPostcode(data.post_code))
      .then(() => {
        dispatch(action(data));
      })
      .catch((error) => {
        dispatch(postPostcodeFailure({ post_code: error.message }));
      })
  }
}

const isValidPostcode = (responseObj) => {
  return responseObj && responseObj.status === HTTP_200_OK_CODE && responseObj.data.results !== null && responseObj.data.results.length > 0;
}



// WEBPACK FOOTER //
// ./src/redux/actions/Postcode.js